import { clampTo, hasImageInput } from '../../tools';
import type { GeneralImageModelConfig } from '../../general-provider';

export const openaiConfigs: Record<string, GeneralImageModelConfig> = {
    'vxp-gpt-image-2': {
        apiPath: ({ hasImage }) => hasImage ? '/v1/images/compositions' : '/v1/images/generations',
        synchronous: true,
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    model: 'vxp-gpt-image-2',
                    prompt: prompt,
                    ratio: aspectRatio === 'match' ? undefined : clampTo(aspectRatio || '16:9', ['1:1', '16:9', '9:16', '4:3', '3:4'] as const, '16:9'),
                    quality: '1080p',
                    // 图片 URL
                    images: image_urls.slice(0, 9),
                    // 可选参数
                    detail_level: 'medium',
                };
            }
            return {
                model: 'vxp-gpt-image-2',
                prompt: prompt,
                ratio: aspectRatio === 'match' ? undefined : clampTo(aspectRatio || '16:9', ['1:1', '16:9', '9:16', '4:3', '3:4'] as const, '16:9'),
                quality: '1080p',
                // 可选参数
                detail_level: 'medium',
            };
        },
    },
};